<template>

    <Page>

        <h1 class="text-2xl font-semibold 2xl:px-20 w-full">Reseller Benefits</h1>
        <ul class="mt-3 list-disc text-white font-normal text-xl 2xl:px-20">
            <li class="pl-2 ml-5 mb-3">
                <span class="font-semibold text-cyan-400">Exclusive</span> territory rights
            </li>
            <li class="pl-2 ml-5 mb-3">
                <span class="font-semibold text-cyan-400">10% equity</span> in Connected Vehicles UK
            </li>
            <li class="pl-2 ml-5 mb-3">
                A <span class="font-semibold text-cyan-400">50/50 profit share</span> model for all current and future products
            </li>
            <li class="pl-2 ml-5 mb-3">
                Full product support, marketing assets, training, and integration help and the <span class="font-semibold text-cyan-400">opportunity to build a highly profitable, recurring revenue
                business with very little overhead.</span>
            </li>
        </ul>

        <p class="mt-5 text-xl 2xl:px-20">
            With a proven product, clear value proposition, and early momentum, the timing is ideal for a well-connected industry player to take the lead in
            bringing Connected Vehicles to the UK market.
        </p>

    </Page>

</template>